import React from 'react'
import './footer.css'

export default function Footer() {
    return (
        <div>
            <h4 className='footer text-center'>
            Made by Yogi Katba
            </h4>
        </div>
    )
}
